﻿
const Lazy = {}
/*
* Check for IntersectionObserver support
*/
Lazy.support =  () => {
    return typeof window !== "undefined" && window.IntersectionObserver;
};

/*
* Find height of background-image and add to element style
*/
Lazy.addHeightToBackgroundContainer = function (img, element) {
    let myImage = new Image();
    myImage.src = img;
    myImage.onload = () => {
        element.style.height = myImage.height + "px";
        element.style.backgroundSize = "cover";
    }
}

/*
* Find element
* 'data-original' and replace 'src'
* or
* 'data-background-image' and add style to element 
*/
Lazy.loadImages =  (element) => {
    if (element.getAttribute("data-original")) {
        element.src = element.getAttribute("data-original");

    } else if (element.getAttribute("data-background-image")) {
        const image = element.getAttribute("data-background-image");
        if (image !== "") {
            Lazy.addHeightToBackgroundContainer(image, element);
            element.style.backgroundImage = "url('" + image + "')";
        }
    }
};

/*
* This is called everytime an element comes into view
*/
Lazy.lazyLoading = (elements, observer) => {

    elements.forEach((item) => {
        const image = item.target;
        if (item.intersectionRatio > 0) {
            Lazy.loadImages(image);
            observer.unobserve(image);
        }
    });
};

/*
*  Setup IntersectionObserver on elements
*/
Lazy.lazyLoadElements = (elements) => {
    let hdLazyLoad = document.getElementById("hdLazyLoad"), //value set from content
        rootMarginValue = hdLazyLoad && hdLazyLoad.value ? hdLazyLoad.value : 0;

    if (Lazy.support()) {
        const observer = new IntersectionObserver(Lazy.lazyLoading, {
            rootMargin: rootMarginValue + "px",
            threshold: 0,
        });
        for (let i = 0; i < elements.length; i++) {
            observer.observe(elements[i]);
        }
    } else {
        /* no IntersectionObserver support - load immediately */
        for (let i = 0; i < elements.length; i++) {
            Lazy.loadImages(elements[i]);
        }
    }
};

/*
* When myEvent happens on baseSelector
* Load src on elementSelector
*/
Lazy.loadOnEvent = (baseSelector, elementSelector, myEvent) => {

    const root = document.querySelector(baseSelector),
        elements = document.querySelectorAll(elementSelector);
    if (root && elements.length) {
        root.addEventListener(myEvent, function loadSrcs(event) {
            for (let i = 0; i < elements.length; i++) {
                Lazy.loadImages(elements[i]);
            }
            event.currentTarget.removeEventListener(event.type, loadSrcs);
        });
    }
};

/*
* add lazy loading to elements with specific selector
*/
Lazy.load = (selector) => {
    let lazyElements = document.querySelectorAll(selector);
    if (lazyElements) {
        Lazy.lazyLoadElements(lazyElements);
    }
};
//Initialize lazyloading on all .lazy elements 
export default Lazy;
